import { ITag } from "Domain/Model/Tag/Tag";

export const CREATE_TAG_REQUEST = 'CREATE_TAG_REQUEST';

export const createTagRequest = ( payload: ITag ) => ({
    type: CREATE_TAG_REQUEST,
    payload,
});
